module.exports = __webpack_public_path__ + "static/media/apples.440d0bcd.jpg";